import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { pendingFlag, PendingFlag } from '@platform/shared/utilities/pending-flag';
import { ConfirmDialogComponent } from '@platform/components/confirm-dialog/confirm-dialog.component';
import { DialogV2Service } from '@platform/dialog/dialog-v2.service';
import { User } from '@core/core.state';

export interface IComment {
  id: string;
  text: string;
  createdBy: User;
  createdOn: Date;
}

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentComponent<T extends IComment> {
  @Input({ required: true }) comment: T;
  @Input({ required: true }) currentUserId: string;
  @Input({ required: true }) deleteComment: (comment: T, pendingFlag: PendingFlag) => void;

  public deletePendingFlag = pendingFlag();

  constructor(private dialogService: DialogV2Service) {}

  public showDeleteCommentDialog() {
    this.dialogService
      .open(ConfirmDialogComponent, {
        data: {
          titleTranslationKey: 'comments.delete-task-comment.title',
          textTranslationKey: 'comments.delete-task-comment.confirm-message',
        },
      })
      .afterClosed()
      .subscribe((data) => {
        if (data?.isConfirmed) {
          this.deleteComment(this.comment, this.deletePendingFlag);
        }
      });
  }
}
